const API_ENDPOINT = {
    campaign: {
        list: `/campaign`,
        get: `/campaign/`,
        updateCampaign: '/campaign/update/',
        deleteCampaign: '/campaign/delete/',
        getCampaignDetail: '/campaign/detail/',
        getQuestionPage: '/question-page/detail/',
        updateQuestionPage: '/question-page/update/',
        updateQuestionPageOrder: '/question-page/update-order/',
        createQuestionPage: '/question-page/create',
        deleteQuestionPage: '/question-page/delete/',
        getQuestion: '/question/',
        searchQuestion: '/question/search?s=',
        getQuestionDetail: '/question/detail/',
        createQuestion: '/question/create',
        updateQuestion: '/question/update/',
        deleteQuestion: '/question/delete/',
        attachQuestion: '/question/attach',
        detachQuestion: '/question/detach',
        updateQuestionOrder: '/question/update-order/',
        getLeadtypeDetail: '/lead-requirement-set/detail/',
        updateLeadtypeDetail: '/lead-requirement-set/update/',
        createLeadtypeDetail: '/lead-requirement-set/create',
        deleteConversionType: '/lead-requirement-set/delete/',
        createRequirements: '/requirements/create/',
        updatePipe: '/pipes/',
        deletePipe: '/pipes/',
        updateActivePipe: '/pipes/set-active/'
    }
}
export default API_ENDPOINT
